import React from "react";

interface ModeRendererProps {
  brand: string;
  today: string;
  Copy: string;
}

export function VasarelyAxaMode({ brand }: ModeRendererProps) {
  const width = 794;
  const height = 1123;

  return (
    <svg width={width} height={height} xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="axaGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: "#00008F", stopOpacity: 1 }} />
          <stop offset="50%" style={{ stopColor: "#0033A0", stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: "#4169E1", stopOpacity: 1 }} />
        </linearGradient>
      </defs>
      <rect width={width} height={height} fill="url(#axaGradient)" />
      <g transform={`translate(${width / 2}, ${height / 2})`}>
        {Array.from({ length: 12 }).map((_, layer) => {
          const size = 100 + layer * 40;
          return (
            <rect
              key={`shield-${layer}`}
              x={-size / 2}
              y={-size / 2}
              width={size}
              height={size}
              fill="none"
              stroke="#FFFFFF"
              strokeWidth={2}
              opacity={0.3 - layer * 0.018}
              rx={8}
            />
          );
        })}
        {Array.from({ length: 18 }).map((_, r) => (
          <circle
            key={`protection-${r}`}
            cx={0}
            cy={0}
            r={(r + 1) * 22}
            fill="none"
            stroke="#4169E1"
            strokeWidth={r % 3 === 0 ? 2.5 : 1.5}
            opacity={0.25 - r * 0.01}
          />
        ))}
        <circle cx={0} cy={0} r={60} fill="none" stroke="#FFFFFF" strokeWidth={3} opacity={0.6} />
        <circle cx={0} cy={0} r={40} fill="#0033A0" opacity={0.4} />
      </g>
    </svg>
  );
};
